import { Component, inject, Input, OnInit } from '@angular/core';

import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { cloneDeep } from 'lodash';
import { TeamAdminApiService } from '@services/team-admin-api.service';
import { sortBy } from '@utils/sort-by';
import { ToastrService } from '@services/toaster.service';
import { ButtonComponent, LoaderModule } from '@mds/ui';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-sso-settings',
  standalone: true,
  imports: [
    FormsModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    LoaderModule,
    ButtonComponent,
    MatDialogModule
],
  templateUrl: './sso-settings.component.html',
  styleUrls: ['../../team-common.scss', './sso-settings.component.scss']
})
export class SsoSettingsComponent implements OnInit {
  @Input() teamRid: string;
  msForm: any;
  tagCtrl = new UntypedFormControl();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  private teamAdminApiService = inject(TeamAdminApiService);
  private toastr = inject(ToastrService);

  ngOnInit(): void {
    this.loadSsoData();
  }

  loadSsoData() {
    this.teamAdminApiService.getSSOData(this.teamRid).subscribe((res) => {
      this.msForm = cloneDeep(res);
      sortBy(this.msForm, 'sortlevel');
    });
  }

  ssoSubmit() {
    const payload: Record<string, any> = {};
    for (const i in this.msForm) {
      payload[this.msForm[i].key] = this.msForm[i].value;
    }
    if (
      payload.id &&
      payload.secret &&
      payload.tenant &&
      payload.url &&
      payload.id.length &&
      payload.secret.length &&
      payload.tenant.length &&
      payload.url.length
    ) {
      this.teamAdminApiService.ssoCreateNew(payload).subscribe(() => {
        this.toastr.showMessage('Successfully created', 1000);
      });
    } else {
      this.teamAdminApiService.ssoCreateNewPut(payload).subscribe(() => {
        this.toastr.showMessage('Successfully updated', 1000);
      });
    }
  }

  remove(tag, field): void {
    const index = field.indexOf(tag);
    if (index >= 0) {
      field.splice(index, 1);
    }
  }

  add(event: MatChipInputEvent, field) {
    const { input } = event;
    const value = event.value.trim();

    if (field.includes(value)) {
      return;
    }
    // Add our fruit
    if ((value || '').trim()) {
      field.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
      this.tagCtrl.setValue(null);
    }
  }
}
